import { IMemberJoinState } from './state';
import { createReducer, on, Action } from '@ngrx/store';
import {
  onNgrxForms,
  onNgrxFormsAction,
  SetValueAction,
} from 'ngrx-forms';
import {
  NextStepAction,
  PreviousStepAction,
  GoToStepAction,
  SetErrorPageDataAction,
  ErrorUpdatingAction,
  SignupCompletedAction,
} from './actions';

const state: IMemberJoinState = {
  currentStep: 0,
  errorPage: null,
  errorUpdating: false,
  completed:false
};


const reducer = createReducer(
  state,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, action) => {
    return state;
  }),
  on(SetErrorPageDataAction, (state, { data }) => {
    return {
      ...state,
      errorPage: data,
    };
  }),
  on(GoToStepAction, (state, { index }) => {
    return {
      ...state,
      currentStep: index,
      validated: false,
    };
  }),
  on(NextStepAction, (state) => {
    return {
      ...state,
      currentStep: state.currentStep + 1,
      validated: false,
    };
  }),
  on(PreviousStepAction, (state) => {
    return {
      ...state,
      currentStep: state.currentStep - 1,
      validated: false,
    };
  }),
  on(ErrorUpdatingAction, (state) => {
    return {
      ...state,
      errorUpdating: true,
    };
  }),
  on(SignupCompletedAction, (state) => {
    return {
      ...state,
      completed:true,
      currentStep: state.currentStep + 1,
    }
  })
);

export function memberJoinReducer(state: any | undefined, action: Action) {
  return reducer(state, action);
}
